import React from "react";
import About from "./About";
import Home from "./Home";
import Projects from "./Projects";


const Main = () => {
  return (
    <div>
      <Home />
      <About />
      <Projects />
    </div>
  );
};

export default Main;
